module.exports = __webpack_public_path__ + "img/007-innovation.1e60d086.svg";